{
  "home": {
    "title": "AquaWorks | 学生主导的水质监测",
    "description": "AquaWorks 是由不列颠哥伦比亚大学学生开发的学生主导工程项目。本站位于不列颠哥伦比亚大学温哥华校园。"
  },
  "about": {
    "title": "AquaWorks 第一阶段项目路线图",
    "description": "了解 AquaWorks 第一至三阶段路线图：目标、子系统、范围边界，以及从建造到 2027 年 1 月交接档案的项目时间线。"
  },
  "science": {
    "title": "水质指标与温哥华校园雨水背景 | AquaWorks",
    "description": "说明为何温哥华校园需要移动水质监测、雨水背景、五项核心指标，以及 AquaWorks 如何对齐可持续发展目标（SDG）。"
  },
  "team": {
    "title": "AquaWorks 团队 — 软件、电气、机械与商务",
    "description": "认识 AquaWorks 项目负责人与四支学生子团队：软件、电气、机械与商务。项目由不列颠哥伦比亚大学学生开发。"
  },
  "updates": {
    "title": "AquaWorks 第一阶段建造日志与里程碑",
    "description": "跟踪 AquaWorks 第一阶段里程碑：从立项、受控水体验证，到 2027 年 1 月交给后续学生团队的交接档案。"
  },
  "updateDetail": {
    "title": "{{title}} | AquaWorks 动态",
    "description": "{{summary}}"
  },
  "getInvolved": {
    "title": "加入 AquaWorks — 学生水质监测团队",
    "description": "加入 AquaWorks 学生子团队。不列颠哥伦比亚大学的学生可联系项目负责人，了解加入、咨询与第一阶段事宜。"
  },
  "notFound": {
    "title": "页面未找到 — 404 | AquaWorks",
    "description": "该 AquaWorks 页面不存在。请返回首页，或查看项目、科学与加入页面。"
  }
}
